export default "__VITE_ASSET__fkOmtAS3__"